import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HistoricoPreco } from 'src/app/models/historico-preco';
import { Produto } from 'src/app/models/produto';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-historico-do-preco-modal',
  templateUrl: './historico-do-preco-modal.component.html',
  styleUrls: ['./historico-do-preco-modal.component.scss']
})
export class HistoricoDoPrecoModalComponent implements OnInit, OnDestroy {

  // variáveis
  // produtos: Produto[] = [];
  historicos: HistoricoPreco[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  produto: Produto = new Produto();

  periodoSelecionado = 0;

  mostrarCodErp = false;
  idFornecedor;

  // options
  legend: boolean = false;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = false;
  showXAxisLabel: boolean = false;
  xAxisLabel: string = 'Data';
  yAxisLabel: string = 'Valor';
  timeline: boolean = true;

  colorScheme = {
    domain: ['#f5a505']
  };

  dados: any[] = [];

  constructor(private utilitarioService: UtilitarioService, private premissasService: PremissasService, private produtoService: ProdutoService,
    private router: Router, private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private globalService: GlobalService,
    public dialogRef: MatDialogRef<HistoricoDoPrecoModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) { }

  async ngOnInit() {

    this.buscarMostrarCodErp();

    this.produto = this.data.produto;
    this.idFornecedor = this.data.idFornecedor;

    this.buscarHistorico();
  }

  buscarHistorico() {
    this.carregandoService.mostra('buscarHistorico');

    this.produtoService.consultarHistoricoDoPreco(this.produto.idProduto, this.periodoSelecionado, this.idFornecedor).subscribe(dados => {
      this.historicos = dados;

      if (this.historicos === null || this.historicos === undefined || this.historicos.length === 0) {
        this.dados = [...[{ name: '', series: [ { name: '', value: 0, usuario: '' }] }]];
      } else {
        this.dados = [...[{ name: '', series: this.historicos.map(p => { return { name: p.dataHora, value: p.valor, usuario: p.usuario }; }) }]];
      }

      this.carregandoService.esconde('buscarHistorico');
    }, (erro) => {
      this.carregandoService.esconde('buscarHistorico');
      this.notificacaoService.erro(erro);
    });
  }

  alterarPeriodo(periodo){
    this.periodoSelecionado = periodo;
    this.buscarHistorico();
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {

  }

  buscarMostrarCodErp() {
    this.carregandoService.mostra('buscarMostrarCodErp');
    this.premissasService.consultarMostrarCodErp().subscribe(f => {
      this.mostrarCodErp = f.valor;
      this.carregandoService.esconde('buscarMostrarCodErp');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarCodErp');
      this.notificacaoService.erro(erro);
    });
  }

  formatarValor(valor: Number) {
    return 'R$ ' + valor.toLocaleString();
  }

  formatarData(valor) {
    return new Date(valor).toLocaleDateString();
  }

}
